export default __webpack_public_path__ + "static/media/bettercareOG.6570f0ce.png";